import { render, staticRenderFns } from "./openCustomers.vue?vue&type=template&id=0fb33eeb&scoped=true&"
import script from "./openCustomers.vue?vue&type=script&lang=js&"
export * from "./openCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb33eeb",
  null
  
)

export default component.exports